module.exports = __webpack_public_path__ + "img/汽车展厅亮.6d47d1b9.png";